import React, { useEffect, useState } from "react";
import { profileconfig } from "../../configurations/profileconfig";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
} from "antd";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { RightOutlined } from "@ant-design/icons";
import { utilities } from "../../utilities/utlities";
export default function SecondStep(props) {
  const { Content } = Layout;
  const { Title,Text} = Typography;
  const loggedUser = utilities.loggedUser()
  const [userData, setUser] = useState()
  const [errorMessage,setError] = useState(false)
  var error = {}

  useEffect(() => {
    setUser(props.userdata)

  }, [props.userdata, userData])
  const NextStep = () => {
    if(userData?.firstName == undefined){
      setError(true)
      return
    }
    if(userData?.lastName == undefined){
      setError(true)
      return
    }
    if(userData?.mobileNumber == undefined){
      setError(true)
      return
    }
    if(userData?.jobTitle == undefined){
      setError(true)
      return
    }

    if(loggedUser?.type == "distributor"){
      if(userData?.department == undefined){
        setError(true)
        return
      }
    }
    else{
      if(userData?.surname == undefined){
        setError(true)
        return
      }
      if(userData?.title == undefined){
        setError(true)
        return
      }

      
    }
    setError(false)
    props.CompleteRegistration(2)
  }
  return (

    <Card style={{ width: 300 }} bordered={true} className="login-container">
      <Form
        autoComplete="off"
        className="loginForm"
        layout="vertical"
        name="nest-messages"
        onFinish={() => { }}
        validateMessages={() => { }}
      >
        {
          profileconfig[loggedUser.type]['2'].fields.map((item) => {
            if (item?.type == 'Label') {
              return <Form.Item>
                <Title level={5}>
                  {item.label}
                </Title>
              </Form.Item>
            }
            else if (item?.type == "Text") {
              return <Form.Item
                className={item.itemclass}
              >
                <Text>{item?.label}</Text>
                {item?.require == true ? <Text type="danger">*</Text>:null}
                <Input
                  id={item.id}
                  size={item.size}
                  disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  className={`${props?.objectKeys?.includes(item.label2)== true?'warningMessage':''}`}
                  onChange={(e) => {
                    props.updateCompanyDetails(item.key, e.target.value,item.name,item?.label2)
                  }}
                  value={userData?.[item.name]}
                />
                {errorMessage ==  true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined  ?  <Text type="danger">{item?.errorMessage}</Text>:null:null}

              </Form.Item>
            }
            else if (item.type == "Phone") {
              return <Form.Item
                className={item.itemclass}
              >  <Text>{item?.label}</Text>
              {item?.require == true ? <Text type="danger">*</Text>:null}
                <PhoneInput
                disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                className={`${props?.objectKeys?.includes(item.label2)== true?'warningMessage':''}`}
                  value={userData?.[item.name]}

                  country='pk'
                  id="regPhone"
                  onChange={(Phone) => {
                    props.updateCompanyDetails(item.key, `+${Phone}`,item.name,item?.label2)
                  }
                  }

                />
                {errorMessage ==  true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined  ?  <Text type="danger">{item?.errorMessage}</Text>:null:null}
              </Form.Item>
            }
            else {
              return <Form.Item className={item?.itemclass}>
                <Button
                  type="primary"
                  className={item.elementclass}
                  size={item.size}
                  loading={props.loading}
                  onClick={() => {
                    NextStep()
                  }}
                >
                  {item.label} <RightOutlined />
                </Button>
              </Form.Item>
            }
          })
        }
      </Form>
    </Card>
  );
}
